module.exports = __webpack_public_path__ + "img/gerenshezhi.7c426744.png";